import { isRequired } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.integrations && values.integrations.length) {
    const integrations = values.integrations;
    const integrationsArrayErrors = [];

    integrations.forEach((item, index) => {
      const integrationsErrors = {};
      if (item.integrationPlatform === 'Trekksoft') {
        if (isRequired(item.merchantName, true)) {
          integrationsErrors['merchantName'] = 'Merchant name is required';
          integrationsArrayErrors[index] = integrationsErrors;
        }
        if (isRequired(item.apiClientId || '', true)) {
          integrationsErrors['apiClientId'] = 'Client id is required';
          integrationsArrayErrors[index] = integrationsErrors;
        }
        if (isRequired(item.apiClientSecret || '', true)) {
          integrationsErrors['apiClientSecret'] = 'Client secret is required';
          integrationsArrayErrors[index] = integrationsErrors;
        }
      }
      if (
        item.integrationPlatform === 'Expedia' ||
        item.integrationPlatform === 'BOOKING'
      ) {
        if (isRequired(item.username, true)) {
          integrationsErrors['username'] = 'Username is required';
          integrationsArrayErrors[index] = integrationsErrors;
        }
        if (isRequired(item.password || '', true)) {
          integrationsErrors['password'] = 'Password is required';
          integrationsArrayErrors[index] = integrationsErrors;
        }
      }
    });
    if (integrationsArrayErrors.length) {
      errors.integrations = integrationsArrayErrors;
      errors.integrations = {
        ...integrationsArrayErrors,
        _error: { ...integrationsArrayErrors }
      };
    }
  }

  return errors;
};

export default validate;
